import { Table } from '@mantine/core'
import { Badge, Stack, Text } from 'components'
import { useArcTranslation } from 'hooks'
import type { FrameworkItem } from './types'
import { TrackerScore } from './TrackerScore'

const SCORE_COL_WIDTH = 100

const ItemCell = ({ item }: { readonly item: FrameworkItem }) => (
  <Stack spacing={6}>
    {item.lv1Name && (
      <Badge
        variant='filled'
        radius='sm'
        size='sm'
        sx={{
          alignSelf: 'flex-start',
          backgroundColor: item.color || '#7DCEA0',
          color: '#fff',
          textTransform: 'uppercase',
        }}
      >
        {item.lv1Name}
      </Badge>
    )}
    {item.breadcrumb && (
      <Text size='xs' color='dimmed' lineClamp={2}>
        {item.breadcrumb}
      </Text>
    )}
    <Text size='sm'>
      {item.originalCodes && <strong>{item.originalCodes}</strong>}
      {item.originalCodes && item.name ? ' — ' : ''}
      {item.name}
    </Text>
  </Stack>
)

interface TrackerTableProps {
  readonly items: readonly FrameworkItem[]
}

export const TrackerTable = ({ items }: TrackerTableProps) => {
  const { t } = useArcTranslation()
  const tooltip = t('arc_development_tracker.score_tooltip')

  return (
    <Table highlightOnHover withBorder verticalSpacing='md' horizontalSpacing='md'>
      <thead>
        <tr>
          <th>{t('arc_development_tracker.col_curriculum_item')}</th>
          <th style={{ width: SCORE_COL_WIDTH }}>{t('arc_development_tracker.col_assessment_result')}</th>
        </tr>
      </thead>
      <tbody>
        {items.map(item => (
          <tr key={item.id}>
            <td>
              <ItemCell item={item} />
            </td>
            <td>
              <TrackerScore score={item.assessmentAverage} tooltip={tooltip} />
            </td>
          </tr>
        ))}
      </tbody>
    </Table>
  )
}
